  $(document).ready(function() {
  var screen = $(window).width();

    $(window).scroll(function() {
      var scroll = $(window).scrollTop();
      var windowHeight = $(window).height();

      function handleScroll(element, offset, cssPropsVisible, cssPropsHidden) {
        $(element).each(function() {
          var iconPosition = $(this).offset().top + offset;
          if (iconPosition < (scroll + windowHeight)) {
            $(this).css(cssPropsVisible);
          } else {
            $(this).css(cssPropsHidden);
          }
        });
      }
 if (screen < 700) {
   handleScroll('.second_section_text_microsite_head, .microsite-rewards h2, .judging-criteria_heading, .categories-section p', 0, {'transform': 'translateY(0)', 'opacity': '1'}, {'transform': 'translateY(100px)', 'opacity': '0.1'});
      handleScroll('.cstm_animation_1, .cstm_animation_2, .cstm_animation_3, .cstm_animation_4, .cstm_animation_5, .cstm_animation_6, .cstm_animation_7, .cstm_animation_8, .cstm_animation_9, .cstm_animation_10, .cstm_animation_11, .cstm_animation_12, .cstm_animation_13, .cstm_animation_14, .cstm_animation_15', 0, {'opacity': '1'}, { 'opacity': '0.1'});
// handleScroll('.microsite-rewards h2', 0, {'transform': 'translateY(0)', 'opacity': '1'}, {'transform': 'translateX(100%)', 'opacity': '0.1'});
// handleScroll('.judging-criteria_heading', 0, {'transform': 'translateX(0)', 'opacity': '1'}, {'transform': 'translateX(-100%)', 'opacity': '0.1'});
// handleScroll('.categories-section p', 0, {'transform': 'translateX(0)', 'opacity': '1'}, {'transform': 'translateX(-100%)', 'opacity': '0.1'});
 }else{
      handleScroll('.second_section_text_microsite_head, .microsite-rewards h2, .judging-criteria_heading, .categories-section p', 150, {'transform': 'translateY(0)', 'opacity': '1'}, {'transform': 'translateY(100px)', 'opacity': '0.1'});
      handleScroll('.cstm_animation_1, .cstm_animation_2, .cstm_animation_3, .cstm_animation_4, .cstm_animation_5, .cstm_animation_6, .cstm_animation_7, .cstm_animation_8, .cstm_animation_9, .cstm_animation_10', 180, {'opacity': '1'}, { 'opacity': '0.1'});
// handleScroll('.microsite-rewards h2', 150, {'transform': 'translateY(0)', 'opacity': '1'}, {'transform': 'translateX(100%)', 'opacity': '0.1'});
// handleScroll('.judging-criteria_heading', 150, {'transform': 'translateX(0)', 'opacity': '1'}, {'transform': 'translateX(-100%)', 'opacity': '0.1'});
// handleScroll('.categories-section p', 150, {'transform': 'translateX(0)', 'opacity': '1'}, {'transform': 'translateX(-100%)', 'opacity': '0.1'});
      }
      
    });
});